import React from 'react';
import { OceanIcon } from './icons';
import { trackClick } from '../utils/analytics';

/**
 * Ocean — not built yet, so this page exists to say so honestly and to let
 * someone register interest by upgrading.
 *
 * The CTA is hidden for anyone already on a paid plan: telling a Voyager
 * subscriber to "upgrade to Voyager" is the kind of small wrongness that makes
 * a product feel careless, and they already have the early access on offer.
 */

interface OceanPageProps {
    /** True when the account is already on a paid plan. */
    isPaid?: boolean;
    /** Opens the upgrade flow. Omitted for paid accounts. */
    onUpgrade?: () => void;
}

export const OceanPage: React.FC<OceanPageProps> = ({ isPaid = false, onUpgrade }) => (
    <div className="flex-1 flex items-center justify-center p-6 overflow-y-auto">
        <div className="max-w-xl w-full flex flex-col items-center text-center gap-4 py-12">
            <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center text-primary-700">
                <span className="scale-150"><OceanIcon active /></span>
            </div>

            <h1 className="text-grayscale-1300 font-grotesk text-3xl font-bold">
                Coming Soon!
            </h1>

            <p className="text-grayscale-1300 font-grotesk text-base">
                Largest, first of its kind problem statement registry.
            </p>
            <p className="text-grayscale-1200 font-grotesk text-base">
                Find companies for licensing &amp; collaboration.
            </p>

            {isPaid ? (
                <div className="mt-4 px-4 py-3 rounded-xl bg-primary-100/60 text-primary-700 font-grotesk text-sm">
                    Your plan includes early access — we'll be in touch as soon as Ocean opens.
                </div>
            ) : (
                <button
                    type="button"
                    onClick={() => {
                        trackClick('ocean_click_upgrade', { source: 'ocean_coming_soon' });
                        onUpgrade?.();
                    }}
                    className="mt-4 py-3 px-6 rounded-full bg-primary-500 text-grayscale-100 font-grotesk text-sm font-medium hover:bg-primary-600 transition-colors"
                >
                    Upgrade to Voyager for early access
                </button>
            )}
        </div>
    </div>
);

export default OceanPage;
